import styled from 'styled-components'

export const ModalBodyText = styled.div`
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  width: 100%;
`
